import { createNativeStackNavigator } from '@react-navigation/native-stack';
import RootGalleriesScreen from 'src/presentation/screens/RootGalleriesScreen';
import RootGalleryHolderScreen from 'src/presentation/screens/RootGalleryHolderScreen';
import RootGalleryScreen from 'src/presentation/screens/RootGalleryScreen';
import Constants from 'src/core/utils/Constants';
import type { GalleryStackParamList } from 'src/presentation/navigation/types/NavigationTypes';

const GalleryStack = createNativeStackNavigator<GalleryStackParamList>();

function GalleryStackNavigator() {
	return (
		<GalleryStack.Navigator initialRouteName={Constants.screenRootGalleries} screenOptions={{ headerShown: false }}>
			<GalleryStack.Screen component={RootGalleriesScreen} name={Constants.screenRootGalleries} />
			<GalleryStack.Screen component={RootGalleryHolderScreen} name={Constants.screenRootGalleryHolder} />
			<GalleryStack.Screen component={RootGalleryScreen} name={Constants.screenRootGalleryPage} />
		</GalleryStack.Navigator>
	);
}

export default GalleryStackNavigator;
